import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import '../../App.css'

export default forwardRef((props:any, ref) => {
    const inputRef = useRef();
    const [cancel, setCancel] = useState(false);
    const [selectDefaultValue, setSelectDefaultValue] = useState(props.value);

    console.log(props)
    const elementId = props.data[props.colDef.field + '_Id'];
    console.log(elementId)
    useImperativeHandle(ref, () => {
        return {
            getValue: () => {
                //@ts-ignore
                return inputRef.current.value;
            },
            isPopup: () => {
                return true;
            },
            isCancelAfterEnd: ()=>{
                return cancel;
            }
        };
    });

    const confirmChange = (event:React.MouseEvent<HTMLSelectElement>) => {
        const confirmDlg = window.confirm('Bitte Änderung bestätigen: \n alter Wert: ' + props.value + '\n Neuer Wert: ' + event.currentTarget.value);
        if(!confirmDlg){
            setCancel(true);
        }
        else{
            setCancel(false);
            setSelectDefaultValue(event.currentTarget.value)
            props.stopEditing()
        }
    }
    const options = ['+', '(+)', 'o', '(o)', '-', 'kA'] 
    //@ts-ignore
    const input2 = <select ref={inputRef} value={selectDefaultValue} onChange={confirmChange}>
        {options.map((val) => {
            return <option key={val}>{val}</option>
    })}
    </select>
    return (
        <div className="rs-cell-editor">
            {elementId ? <p><b>Datenpunkt bearbeiten</b></p> : <p><b>Element erstellen</b></p>}
        <span>Eignung</span><br/>
        {input2} <br/>
        {elementId ? <a rel="noopener noreferrer" href={'https://sp.gemue.biz/gemuepedia/Lists/Resistance_list_new/EditForm.aspx?ID=' + elementId} target="_blank">Weitere Eigenschaften bearbeiten</a> : null }
        </div>
    );
})